var mixin = {
	methods: {
		loadCSS (href, attr) {
			return new Promise(function (resolve) {
				const tag = document.createElement('link')
				tag.setAttribute('href', href)
				tag.setAttribute('media', 'all')
				tag.setAttribute('rel', 'stylesheet')
				if (attr) {
					for (var key in attr) {
						tag.setAttribute(key, attr[key])
					}
				}
				tag.onload = () => {
					resolve()
				}
				document.head.appendChild(tag)
			})
		},
		loadJS (src, attr) {
			return new Promise(function (resolve) {
				const tag = document.createElement('script')
				tag.setAttribute('src', src)
				tag.setAttribute('type', 'text/javascript')
				if (attr) {
					for (var key in attr) {
						tag.setAttribute(key, attr[key])
					}
				}
				tag.onload = () => {
					resolve()
				}
				document.head.appendChild(tag)
			})
		},
		loadGoogleMapApiJS (customAttrs) {
			return new Promise((resolve) => {
				if (window.google) {
					return resolve()
				}
				
				const src = `//maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_MAP_API_KEY}&libraries=places,geometry&language=VI`
				const attr = Object.assign({
					id: 'google-map-api'
				}, (customAttrs || {}))

				this.loadJS(src, attr).then(() => {
					resolve()
				})		
			})				
		},
		loadMapboxApiJS () {
			const href = 'https://api.tiles.mapbox.com/mapbox-gl-js/v0.46.0/mapbox-gl.css'
			this.loadCSS(href)

			return new Promise((resolve) => {
				if (window.mapboxgl) {
					return resolve()
				}
				
				this.loadJS('https://api.tiles.mapbox.com/mapbox-gl-js/v0.46.0/mapbox-gl.js', {}).then(() => {
					resolve()
				})
			})
		}
	}
}

export default mixin
